import styled from '@emotion/styled';
import MultiSelect from 'components/Inputs/MultiSelect';
import RelationshipMany from 'components/Fields/FieldInput/RelationshipMany';
import { appBackground } from 'app/colors';
import Button from 'components/Button';
import { scrollbarCss } from 'app/spacing';

const styles = `
  & label {
    margin-bottom: 12px;
  }
  margin-top: 18px; // margin set to this weird value because font types caused mismatch with design, it should be 20px margin
  &.select-wrapper .menu {
    position: relative !important;
    margin-top: -4px;
  }
  & .control {
    border-radius: 4px !important;
  }
`;

export const StyledMultiSelect = styled(MultiSelect)`
  ${styles}
`;

export const StyledRelationshipMany = styled(RelationshipMany)`
  ${styles}
`;

export const StyledDescription = styled.div`
  padding: 10px;
  padding-right: 0;
  background-color: ${appBackground};
  border-radius: 4px;
  max-width: 100%;
  overflow: hidden;
  & > p {
    max-height: 5em;
    overflow-wrap: break-word;
    white-space: pre-wrap;
    overflow-y: auto;
    padding-right: 10px;
    ${scrollbarCss}
  }
`;

export const StyledActionButton = styled(Button)`
  && {
    padding: 0 15px;
  }
`;
